import React from 'react';

interface Props {
  rules: {
    length: boolean;
    uppercase: boolean;
    number: boolean;
    special: boolean;
    match?: boolean;
  };
}

const PasswordRules: React.FC<Props> = ({ rules }) => {
  const { length, uppercase, number, special, match } = rules;
  return (
    <div
      className="p-6 rounded-2xl"
      style={{
        background: 'var(--color-auth-rules-bg)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        border: '1px solid var(--color-auth-rules-border)'
      }}
    >
      <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--color-auth-text)' }}>Password Requirements:</h3>
      <div className="flex flex-col gap-3 text-sm" style={{ color: 'var(--color-auth-rules-text)' }}>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${length ? 'border-[#17c480] bg-[#17c480]' : ''}`} style={!length ? { borderColor: 'var(--color-auth-rules-unchecked)' } : undefined}>
            {length && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>At least 8 characters</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${uppercase ? 'border-[#17c480] bg-[#17c480]' : ''}`} style={!uppercase ? { borderColor: 'var(--color-auth-rules-unchecked)' } : undefined}>
            {uppercase && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One uppercase letter (A-Z)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${number ? 'border-[#17c480] bg-[#17c480]' : ''}`} style={!number ? { borderColor: 'var(--color-auth-rules-unchecked)' } : undefined}>
            {number && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One number (0-9)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${special ? 'border-[#17c480] bg-[#17c480]' : ''}`} style={!special ? { borderColor: 'var(--color-auth-rules-unchecked)' } : undefined}>
            {special && (
              <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </div>
          <span>One special character (!@#$%^&*)</span>
        </div>
        {typeof match !== 'undefined' && (
          <div className="flex items-center gap-2">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${match ? 'border-[#17c480] bg-[#17c480]' : ''}`} style={!match ? { borderColor: 'var(--color-auth-rules-unchecked)' } : undefined}>
              {match && (
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <span>Passwords match</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordRules;
